(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('melt-patch-choice')) {
  customElements.define('melt-patch-choice', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.closest('form');
      if (!this.form) return;
      this.sync();
      if (this.dataset.denimAvailable === 'true') this.form.querySelector('button[type=submit]')?.removeAttribute('disabled');
      for (const type of ['input', 'change']) document.addEventListener(type, event => {
        if (event.target.form === this.form && event.target.name === 'quantity') this.sync();
      }, {signal});
      this.form.addEventListener('submit', event => {
        this.sync();
        if (!this.valid()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('select')?.reportValidity();
        }
      }, {capture: true, signal});
      this.form.addEventListener('formdata', event => {
        if (!this.valid()) return;
        const data = event.formData;
        const id = data.get('id');
        const quantity = this.quantity();
        if (!id) return;
        const properties = Array.from(data.entries()).filter(([key]) => /^properties\[.+\]$/.test(key));
        const plan = data.get('selling_plan');
        data.delete('id'); data.delete('quantity'); data.delete('selling_plan');
        properties.forEach(([key]) => data.delete(key));
        data.set('items[0][id]', id);
        data.set('items[0][quantity]', String(quantity));
        if (plan) data.set('items[0][selling_plan]', plan);
        properties.forEach(([key, value]) => data.append('items[0][' + key.replace('[', ']['), value));
        const counts = new Map();
        this.querySelectorAll('select').forEach(select => counts.set(select.value, (counts.get(select.value) || 0) + 1));
        let index = 1;
        counts.forEach((count, patchId) => {
          data.set(`items[${index}][id]`, patchId);
          data.set(`items[${index}][quantity]`, String(count));
          index++;
        });
      }, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
    quantity() { return Number(this.form.elements.namedItem('quantity')?.value || 1); }
    sync() {
      const quantity = this.quantity();
      if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 100) return;
      const rows = this.querySelector('[data-patch-rows]');
      while (rows.children.length > quantity) rows.lastElementChild.remove();
      while (rows.children.length < quantity) {
        const fragment = this.querySelector('template').content.cloneNode(true);
        fragment.querySelector('[data-patch-label]').textContent = `${rows.children.length + 1}点目のワッペン`;
        rows.append(fragment);
      }
    }
    valid() {
      const selects = Array.from(this.querySelectorAll('select'));
      const quantity = this.quantity();
      const valid = Number.isSafeInteger(quantity) && quantity > 0 && quantity <= 100 && selects.length === quantity && selects.every(select => select.value && !select.selectedOptions[0].disabled);
      const error = this.querySelector('[data-patch-error]');
      error.hidden = valid;
      error.textContent = quantity > 100 ? '一度に追加できるハートパンツは100点までです。' : 'ハートパンツ1点ごとに、在庫のあるワッペンのカラーを選んでください。';
      return valid;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-list"] && !Shopify.designMode) return;
  try {
    const normalizeMaterialText = (value) => (value || '').replace(/\s+/g, '').toLowerCase();

  const getMaterialKey = (value) => {
    const normalizedValue = normalizeMaterialText(value);

    if (normalizedValue.includes('s925')) {
      return 's925';
    }

    if (normalizedValue.includes('真鍮') || normalizedValue.includes('brass')) {
      return 'brass';
    }

    if (normalizedValue.includes('純銅') || normalizedValue.includes('copper')) {
      return 'copper';
    }

    return normalizedValue;
  };

  const getCheckedMaterialText = (summary) => {
    const optionPosition = summary.dataset.materialOptionPosition;

    if (!optionPosition) {
      return '';
    }

    const input = document.querySelector(`input[data-option-position="${optionPosition}"]:checked`);

    if (!input || !input.id) {
      return '';
    }

    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);

    return label ? label.textContent : '';
  };

  const updateMaterialPriceSummary = (summary) => {
    const checkedMaterialText = normalizeMaterialText(getCheckedMaterialText(summary));
    const checkedMaterialKey = getMaterialKey(checkedMaterialText);

    if (!checkedMaterialText) {
      return;
    }

    summary.querySelectorAll('[data-material-price-item]').forEach((item) => {
      const materialValue = normalizeMaterialText(item.dataset.materialValue);
      const materialLabel = normalizeMaterialText(item.dataset.materialLabel);
      const materialKey = item.dataset.materialKey || getMaterialKey(materialValue);
      const isSelected = checkedMaterialKey === materialKey || checkedMaterialText === materialValue || checkedMaterialText === materialLabel;

      item.classList.toggle('is-selected', isSelected);
    });
  };

  const updateAllMaterialPriceSummaries = () => {
    document.querySelectorAll('[data-material-price-summary]').forEach(updateMaterialPriceSummary);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[data-option-position]')) {
      updateAllMaterialPriceSummaries();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('label[for]')) {
      requestAnimationFrame(updateAllMaterialPriceSummaries);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllMaterialPriceSummaries);
  } else {
    updateAllMaterialPriceSummaries();
  }
  } catch(e) { console.error(e); }
})();

})();
